import React from 'react';
import { makeStyles } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles({
  errorText: {
    fontSize: '0.8125rem',
    margin: 0,
    color: '#ec6a21',
    lineHeight: '1'
  },
  errorBox: {
    display: 'flex',
    padding: '0.5rem 1rem',
    alignItems: 'center',
    margin: '1rem 0',
    backgroundColor: '#f7f7f7'
  },
  icon: {
    fill: '#ec6a21',
    width: '1.5rem',
    marginRight: '1rem'
  }
});

interface ErrorProps {
  meta: {
    touched: boolean;
    invalid: boolean;
    error: boolean;
  };
}

const Warn = ({ meta: { error } }: ErrorProps) => {
  const classes = useStyles();
  return error ? (
    <div className={classes.errorBox}>
      <InfoIcon className={classes.icon} />
      <p className={classes.errorText}>{error}</p>
    </div>
  ) : null;
};

export default Warn;
